import { render, staticRenderFns } from "./DiscussionBoardModal.vue?vue&type=template&id=14d06adc&"
import script from "./DiscussionBoardModal.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports